// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__2YsU7","errors":"Errors_errors__1z9QB"};